<div class="contentSection" *ngIf="this.quoteRequestState.ownerUserId !== this.userIdentity.id">
  <h3>
    Add Quote |
    <app-company-quoteid-header
      [quote]="{ organisationName: this.quoteRequestSummary?.companyName, quoteRequestId: this.quoteRequestSummary?.quoteRequestId }"
    >
    </app-company-quoteid-header>
  </h3>

  <!-- Add Quote Start (Create component if needed) -->
  <div class="my-6">
    <p>
      The broker has requested quotes for: Product Type:
      <b>{{ quoteRequestSummary?.productType }}</b>
    </p>
    <p>Please add and submit your quotes below.</p>
  </div>

  <h4 id="supplyDetailsTitle">Supply Details</h4>

  <a class="download-link" appDownloadLink [file]="this.file">Download Usage Data</a>

  <table mat-table [dataSource]="supplyDetailsSource" id="supplyDetailsTable">
    <mat-text-column name="utilityAccountNumber" headerText="Utility Account Number"></mat-text-column>

    <ng-container matColumnDef="loadProfile">
      <th mat-header-cell *matHeaderCellDef>Load Profile</th>
      <td mat-cell class="thinGreyBorder paddingLeftSmall" *matCellDef="let ua" class="inputCell">
        <select class="inputControl" style="height: 100%; width: 100%" name="loadProfile" id="loadProfile" [(ngModel)]="ua.loadProfile" [disabled]="isReadOnly">
          <option *ngFor="let rc of this.rateCodes" [selected]="rc === ua.loadProfile" [ngValue]="rc">{{ rc }}</option>
        </select>
        <!-- Rate Code is Load Profile -->
      </td>
    </ng-container>

    <ng-container matColumnDef="peakLoadContribution" *ngIf="this.quoteRequestSummary?.commodity == Commodity.Electricity">
      <th mat-header-cell *matHeaderCellDef>Peak Load Contribution (PLC)</th>
      <td
        mat-cell
        *matCellDef="let ua"
        class="inputCell thinGreyBorder paddingLeftSmall"
        [ngStyle]="{
          color:
            ua.peakLoadContribution && ua.peakLoadContributionPercentage !== 0 && ua.peakLoadContribution <= 1000000 ? 'inherit' : 'red'
        }"
      >
        <input
          class="inputControl"
          [disabled]="isReadOnly"
          type="number"
          [(ngModel)]="ua.peakLoadContribution"
          (change)="this.calculatePlcLoadFactorPercentage(ua)"
        />
      </td>
    </ng-container>

    <ng-container matColumnDef="plcLoadFactorPercentage" *ngIf="this.quoteRequestSummary?.commodity == Commodity.Electricity">
      <th mat-header-cell *matHeaderCellDef>{{ plcNsplRequirement?.plcLoadFactorLabel }}</th>
      <td
        class="readOnlyCell paddingLeftSmall"
        [ngStyle]="{ color: !this.isPlcBelowCustomerThreshold(ua) && ua.plcLoadFactorPercentage ? 'red' : 'black' }"
        mat-cell
        *matCellDef="let ua"
      >
        <span class="p-4" *ngIf="ua.plcLoadFactorPercentage > 0 && ua.peakLoadContribution <= 1000000">{{
          ua.plcLoadFactorPercentage | number: '1.2-2'
        }}</span>
        <span *ngIf="ua.plcLoadFactorPercentage <= 0 || ua.peakLoadContribution > 1000000">-</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="plcErrors" *ngIf="this.quoteRequestSummary?.commodity == Commodity.Electricity">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let data">
        <span *ngIf="!this.isPlcBelowCustomerThreshold(data) && data.plcLoadFactorPercentage != 0">
          <mat-icon
            color="warn"
            matTooltipPosition="right"
            data-html="true"
            matTooltipClass="enable-line-break ud-tooltip"
            [matTooltip]="getPlcFullValidationMessageStr(data)"
          >
            error</mat-icon
          >
        </span>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="networkServicePeakLoad" *ngIf="this.quoteRequestSummary?.commodity == Commodity.Electricity">
      <th mat-header-cell *matHeaderCellDef>Network Service Peak Load (NSPL)</th>
      <td mat-cell class="thinGreyBorder paddingLeftSmall" *matCellDef="let ua" class="inputCell">
        <input
          [disabled]="isReadOnly"
          class="inputControl"
          type="number"
          [(ngModel)]="ua.networkServicePeakLoad"
          (change)="this.calculateNsplLoadFactorPercentage(ua)"
        />
      </td>
    </ng-container>

    <ng-container matColumnDef="nsplLoadFactorPercentage" *ngIf="this.quoteRequestSummary?.commodity == Commodity.Electricity">
      <th mat-header-cell *matHeaderCellDef>NSPL Load Factor (%)</th>
      <td
        class="readOnlyCell paddingLeftSmall"
        [ngStyle]="{ color: !this.isNsplBelowCustomerThreshold(ua) && ua.nsplLoadFactorPercentage ? 'red' : 'black' }"
        mat-cell
        *matCellDef="let ua"
      >
        <span class="p-4" *ngIf="ua.nsplLoadFactorPercentage > 0 && ua.networkServicePeakLoad <= 1000000">{{
          ua.nsplLoadFactorPercentage | number: '1.2-2'
        }}</span>
        <span *ngIf="ua.nsplLoadFactorPercentage <= 0 || ua.networkServicePeakLoad > 1000000">-</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="nsplErrors" *ngIf="this.quoteRequestSummary?.commodity == Commodity.Electricity">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell class="paddingLeftSmall" *matCellDef="let data">
        <span *ngIf="!this.isNsplBelowCustomerThreshold(data) && data.nsplLoadFactorPercentage != 0">
          <mat-icon
            color="warn"
            matTooltipPosition="right"
            data-html="true"
            matTooltipClass="enable-line-break ud-tooltip"
            [matTooltip]="getNsplFullValidationMessageStr(data)"
          >
            error</mat-icon
          >
        </span>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="newContractStartDate">
      <th mat-header-cell *matHeaderCellDef>New Contract Start Month</th>
      <td mat-cell *matCellDef="let ua">
        {{ ua.newContractStartDate | date: 'MMM-yyyy' }}
      </td>
    </ng-container>

    <mat-text-column name="meterZipCode" headerText="Meter Zip Code"></mat-text-column>

    <tr mat-header-row *matHeaderRowDef="displayedUtilityAccColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedUtilityAccColumns"></tr>
  </table>

  <h4>Quote</h4>

  <div [formGroup]="quoteForm" class="my-6">
    <mat-form-field appearance="standard">
      <mat-label>{{
        'Broker Fee' | unitForCommodityFields: this.quoteRequestSummary?.commodity:QuoteRequestField.CommissionRate
      }}</mat-label>
      <input type="number" matInput formControlName="brokerFee" />
    </mat-form-field>

    <table mat-table [dataSource]="contractLengthRatesSource" id="contractLengthsTable">
      <ng-container matColumnDef="contractLengths">
        <th mat-header-cell *matHeaderCellDef>Contract Length <span style="text-transform: lowercase">(months)</span></th>
        <td
          mat-cell
          class="thinGreyBorder paddingLeftSmall"
          *matCellDef="let sd"
          [ngStyle]="{
            'border-color': sd.contractLength > 0 ? 'inherit' : 'red'
          }"
        >
          <input
            type="text"
            [readOnly]="(!sd.isSweetSpot || this.quoteRequestState.status === 'QuoteRequestApproved') || isReadOnly"
            class="inputControl"
            value="{{ sd.contractLength }}"
            (change)="setContractLength(sd, $event)"
            [ngStyle]="{ width: isSweetSpot(sd) ? '50%' : '100%' }"
          />
          <span style="width: 50%" *ngIf="isSweetSpot(sd)">(SweetSpot)</span>
        </td>
        <td></td>
      </ng-container>

      <ng-container matColumnDef="rate">
        <th mat-header-cell *matHeaderCellDef style="text-align: center">
          Rate <span style="text-transform: none">($/{{ quoteRequestState?.uom }})</span>
        </th>
        <td
          mat-cell
          class="thinGreyBorder paddingLeftSmall"
          *matCellDef="let sd"
          [ngStyle]="{
            'border-color': sd.rate > 0 ? 'inherit' : 'red'
          }"
        >
          <input
            type="text"
            class="inputControl"
            [readonly]="this.quoteRequestState.status === 'QuoteRequestApproved' || isReadOnly"
            (change)="setRate(sd, $event)"
            value="{{ sd.rate }}"
          />
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['contractLengths', 'rate']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['contractLengths', 'rate']"></tr>
    </table>
    <div *ngIf="showMessage">
      <mat-error aria-atomic="true" class="mat-error" aria-live="polite" id="mat-error">
        Please enter at least one price to submit a quote
      </mat-error>
    </div>
  </div>
</div>
